import { jsx as _jsx } from "react/jsx-runtime";
import { playUiSound } from './sound.js';
import { colors, fonts, radii, spacing } from './tokens.js';
const base = {
    fontFamily: fonts.ui,
    fontSize: '14px',
    fontWeight: 600,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    padding: `${spacing.sm} ${spacing.md}`,
    borderRadius: radii.sm,
    // Longhand border properties: React warns when a shorthand and a longhand alternate.
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: colors.border,
    cursor: 'pointer',
};
const variants = {
    primary: { background: colors.accent, color: colors.accentText, borderColor: colors.accent },
    ghost: { background: 'transparent', color: colors.text },
};
export function Button({ variant = 'primary', style, children, onClick, onPointerEnter, ...rest }) {
    return (_jsx("button", { type: "button", style: { ...base, ...variants[variant], ...style }, onClick: (e) => {
            playUiSound('click');
            onClick?.(e);
        }, onPointerEnter: (e) => {
            playUiSound('hover');
            onPointerEnter?.(e);
        }, ...rest, children: children }));
}
//# sourceMappingURL=Button.js.map